import React from 'react';
import DocumentsForm from './DocumentsForm';

const NewDocumentPage = () => {
    return <DocumentsForm formType="create" />;
};

export default NewDocumentPage;
